export const FORM_FIELD_NAMES = {
  confirmPassword: 'confirmPassword',
  password: 'password',
  captchaToken: 'captchaToken',
  securityAnswer: 'securityAnswer',
  securityQuestion: 'securityQuestion',
  termsConditions: 'termsConditions',
  zipCode: 'zipCode',
};

export const ERROR_MESSAGES = {
  confirmPasswordInvalid: 'Invalid password',
  confirmPassword: 'Required',
  passwordInvalid: 'Invalid password',
  password: 'Required',
  securityAnswer: 'Please enter at least 3 characters',
  securityQuestion: 'Required',
  termsConditions: 'Required',
  zipCode: 'Invalid format',
};

export const ACCOUNT_ERROR_TYPES = {
  alreadyRegistered: 'alreadyRegistered',
  inviteExpired: 'inviteExpired',
  terms: 'terms',
};

export const MOCK_SECURITY_QUESTIONS = [
  {
    key: 'FAVORITE_BEVERAGE',
    description: 'What is your favorite beverage?',
  },
  {
    key: 'FAVORITE_MOVIE',
    description: 'What is your favorite movie?',
  },
  {
    key: 'PET_NAME',
    description: "What is your favorite pet's name?",
  },
  {
    key: 'FAVORITE_TEACHER',
    description: 'What is the last name of your favorite teacher?',
  },
  {
    key: 'BEST_FRIEND',
    description: "What is your best friend's name?",
  },
  {
    key: 'SPORTS_TEAM',
    description: 'What is your favorite sports team?',
  },
  {
    key: 'HONEYMOON',
    description: 'Where did you go on your honeymoon?',
  },
  {
    key: 'NIECE_NEPHEW',
    description: 'What is the first name of your oldest niece/nephew?',
  },
  {
    key: 'FIRST_JOB',
    description: 'What is the name of the first company you worked for?',
  },
  {
    key: 'FIRST_CAR',
    description: 'What was your first car (make and model)?',
  },
];

/**
 * The maximum number of validation attempts before showing reCAPTCHA.
 */
export const VALIDATION_ATTEMPT_LIMIT = 3;
